import moment from "moment/src/moment";

// if (typeof navigator !== "undefined" && navigator.language) {
//   moment.locale(navigator.language);
// }

import "moment/src/locale/zh-cn";
moment.locale("zh-cn");

export default moment;
